/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Teams_Queue_DescriptionInputs */

const en_tables_teams_queue_description = /** @type {(inputs: Tables_Teams_Queue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue Description`)
};

const de_tables_teams_queue_description = /** @type {(inputs: Tables_Teams_Queue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue Beschreibung`)
};

/**
* | output |
* | --- |
* | "Queue Description" |
*
* @param {Tables_Teams_Queue_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_teams_queue_description = /** @type {((inputs?: Tables_Teams_Queue_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Teams_Queue_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_teams_queue_description(inputs)
	return de_tables_teams_queue_description(inputs)
});